import React from 'react';
import { useTheme } from 'styled-components/native';
import { useNavigation } from '@react-navigation/native';
import { useAppSelector } from 'hooks/redux';
import useI18n from 'hooks/useI18n';
import { ADJUST_TAX_INFO } from 'constants/routeNames';
import { ADJUST_CALCULATION_TAX_INFO_ROW } from 'constants/testIds/dashboard/adjustCalculation';
import { selectShowGrossAmount } from 'selectors/dashboard';
import AdjustCalculationRow from './AdjustCalculationRow';

const { default: Icon } = require('@sp/ui/base/Icon');
const { Body2 } = require('@sp/ui/v2/typography');

const TaxInfoRow: React.FC = () => {
  const navigation = useNavigation();
  const { COLORS } = useTheme();
  const { i18n } = useI18n(['dashboard']);
  const showGrossAmount = useAppSelector(selectShowGrossAmount);

  return (
    <AdjustCalculationRow
      testID={ADJUST_CALCULATION_TAX_INFO_ROW}
      componentLeft={<Icon name="rowMoneyBag" fill={COLORS.V2_PRIMARY_BACKGROUND} />}
      textLeft={i18n.t('dashboard|showWithGrossAmount')}
      hasRowBorder={false}
      textRight={
        <Body2 fontWeight="normal" color={COLORS.V2_SECONDARY_TEXT}>
          {!showGrossAmount ? i18n.t('yes') : i18n.t('no')}
        </Body2>
      }
      onPress={() => navigation.navigate(ADJUST_TAX_INFO)}
    />
  );
};

export default TaxInfoRow;
